import {Component, Input} from '@angular/core';

@Component({
    selector: 'geo-panel',
    templateUrl: './panel.component.html',
    standalone: false
})
export class PanelComponent {

  @Input() count: number;
  @Input() ariaLabel: string;
}
